<script setup lang="ts">
import { onBeforeUnmount } from 'vue'
import useEmblaProgress from '@scripts/composables/use-embla-progress.js'
import useEmblaTweenOpacity from '@scripts/composables/use-embla-tween-opacity.js'
import emblaCarouselVue from 'embla-carousel-vue'
import { WheelGesturesPlugin } from 'embla-carousel-wheel-gestures'
import Progress from '@components/Progress.vue'

const [emblaRef, emblaApi] = emblaCarouselVue(
    {
        loop: false,
        align: 'start',
        skipSnaps: true,
    },
    [WheelGesturesPlugin()]
)

const progress = useEmblaProgress(emblaApi)
const removeTweenOpacity = useEmblaTweenOpacity(emblaApi)

onBeforeUnmount(() => {
    removeTweenOpacity()
})
</script>

<template>
    <div>
        <div ref="emblaRef">
            <div
                class="-ml-16 flex cursor-grab touch-pan-y touch-pinch-zoom justify-start *:pl-16 active:cursor-grabbing [&_figcaption]:cursor-text"
            >
                <slot />
            </div>
        </div>

        <Progress
            class="mt-12"
            :value="progress"
        />
    </div>
</template>
